export const PURGE_ICON = 'fas fa-broom';
flarum.reg.add('acpl-lscache', 'common/constants', { PURGE_ICON: PURGE_ICON, });